import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Link } from '@zola/zola-ui';

import { getChecklistFilterLabel } from '../helpers';

import './ChecklistActiveFilterTags.less';

const ChecklistActiveFilterTags = ({ taskFilters, toggleFilter, clearAllFilters }) => {
  const noActiveFilters = !taskFilters.length;

  if (noActiveFilters) return null;

  return (
    <div className="checklist__filterTags--container">
      {taskFilters.map((filterKey, index, arr) => {
        // always pair the last filter tag with the clear all
        if (index === arr.length - 1) {
          return (
            <span key={filterKey} className="checklist__filterTags--lastItem">
              <Tag type="filter" onClick={() => toggleFilter(filterKey)}>
                {getChecklistFilterLabel(filterKey)}
              </Tag>
              <Link onClick={clearAllFilters} className="checklist__filterTags--clear">Clear All</Link>
            </span>
          );
        }

        return (
          <Tag type="filter" onClick={() => toggleFilter(filterKey)} key={filterKey}>
            {getChecklistFilterLabel(filterKey)}
          </Tag>
        );
      })}
    </div>
  );
};

ChecklistActiveFilterTags.propTypes = {
  taskFilters: PropTypes.arrayOf(PropTypes.string),
  toggleFilter: PropTypes.func,
};

ChecklistActiveFilterTags.defaultProps = {
  taskFilters: [],
};

export default ChecklistActiveFilterTags;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistActiveFilterTags/ChecklistActiveFilterTags.jsx